export const PolicyStatus = {
  Active: "active",
  Archive: "archive",
} as const;
export type PolicyStatus = (typeof PolicyStatus)[keyof typeof PolicyStatus];
